// reducers/documentReducer.js
import { types } from '../types/types';
import { initialDocument } from '../actions/documentActions';

const initialState = {
    editingDocument: initialDocument,
    loading: false,
    error: null
};

export const documentReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingDocumentInfo:
            return { ...state, editingDocument: action.payload ?? initialDocument };

        case types.clearDocumentInfo:
            return { ...state, editingDocument: initialDocument, error: null };

        default:
            return state;
    }
};